import { FC, useState } from 'react';
import QuizOverview from './QuizOverview';
import QuizLearning from './QuizLearning';
import QuizDataTable from './QuizDataTable';

enum QuizStatTabsType {
  OVERVIEW = 'OVERVIEW',
  LEARNING = 'LEARNING',
  DATA_TABLE = 'DATA_TABLE',
}

interface QuizStatTabsProps {
  quizId: string;
}

const QuizStatTabs: FC<QuizStatTabsProps> = ({ quizId }) => {
  const [selectedTab, setSelectedTab] = useState<QuizStatTabsType>(
    QuizStatTabsType.OVERVIEW
  );

  return (
    <div className="pr-3 pl-5 w-full pt-2">
      <div
        className="p-1 rounded-[20px] bg-[#ecebf0] grid grid-cols-3 gap-1 w-full"
      >
        <div
          className={`rounded-[20px] px-2 py-1 text-center cursor-pointer ${
            selectedTab === QuizStatTabsType.OVERVIEW ? 'bg-white' : ''
          }`}
          onClick={() => setSelectedTab(QuizStatTabsType.OVERVIEW)}
        >
          <span className="text-[14px] font-medium">Overview</span>
        </div>
        <div
          className={`rounded-[20px] px-2 py-1 text-center cursor-pointer ${
            selectedTab === QuizStatTabsType.LEARNING ? 'bg-white' : ''
          }`}
          onClick={() => setSelectedTab(QuizStatTabsType.LEARNING)}
        >
          <span className="text-[14px] font-medium">Learning</span>
        </div>
        <div
          className={`rounded-[20px] px-2 py-1 text-center cursor-pointer ${
            selectedTab === QuizStatTabsType.DATA_TABLE ? 'bg-white' : ''
          }`}
          onClick={() => setSelectedTab(QuizStatTabsType.DATA_TABLE)}
        >
          <span className="text-[14px] font-medium">Data Table</span>
        </div>
      </div>

      {selectedTab === QuizStatTabsType.OVERVIEW && (
        <div>
          <QuizOverview quizId={quizId} />
        </div>
      )}
      {selectedTab === QuizStatTabsType.LEARNING && (
        <div>
          <QuizLearning quizId={quizId} />
        </div>
      )}
      {selectedTab === QuizStatTabsType.DATA_TABLE && (
        <div>
          <QuizDataTable quizId={quizId} />
        </div>
      )}
    </div>
  );
};

export default QuizStatTabs;
